<template>
    <div class="col-12">
        <div class="row px-2">
            <div class="col-sm-4 p-2">
                <span class="span-title">
                    {{ $t('vehicle_editor.registration_number') }}
                </span>
                <input
                    id="license_plate"
                    v-model="licensePlate"
                    :class="['form-control', 'form-control-sm', licensePlate ? 'is-valid' : 'is-invalid']"
                    type="text"
                />
            </div>
            <div class="col-sm-4 p-2">
                <span class="span-title">
                    {{ $t('spreader_data.dry_material') }}
                </span>
                <spreader-material-selector
                    :materialType="this.materialTypes.DRY"
                    :material="this.spreaderData.material_dry"
                    @onMaterialSelection="setMaterial"
                />
            </div>
            <div class="col-sm-4 p-2">
                <span class="span-title">
                    {{ $t('spreader_data.dry_amount') }}
                </span>
                <input
                    type="number"
                    min="0.00"
                    v-model="spreaderData.total_dry_amount"
                    class="form-control"
                />
            </div>
            <div class="col-sm-4 p-2">
                <span class="span-title">
                    {{ $t('spreader_data.liquid_material') }}
                </span>
                <spreader-material-selector
                    :materialType="this.materialTypes.LIQUID"
                    :material="this.spreaderData.material_liquid"
                    @onMaterialSelection="setMaterial"
                />
            </div>
            <div class="col-sm-4 p-2">
                <span class="span-title">
                    {{ $t('spreader_data.liquid_amount') }}
                </span>
                <input
                    type="number"
                    min="0.00"
                    v-model="spreaderData.total_liquid_amount"
                    class="form-control form-control-sm"
                />
            </div>
            <div class="col-sm-4 p-2">
                <span class="span-title">
                    {{ $t('spreader_data.spreader') }}
                </span>
                <span>
                    {{ item.name ? item.name : '-' }}
                </span>
            </div>
            <div class="col-sm-4 p-2">
                <span class="span-title">
                    {{ $t('spreader_data.time') }}
                </span>
                <span>
                    {{ item.start_time ? toLocalTime(item.start_time) : '' }} -  {{ item.end_time ? toLocalTime(item.end_time) : '' }}
                </span>
            </div>
        </div>
        <span class="span-title">{{ $t('spreader_data.edit_spreader_order') }}</span>
        <div class="row nopads">
            <div class="col-sm-6 nopads" style="min-height: 10em">
                <open-contract-filter
                    ref="contracts"
                    :to="item.end_time"
                    :from="item.start_time"
                    :show-company="false"
                    :showOnlyMyContractsOption="true"
                    :show-title="false"
                    :contract="contract"
                    @loading="loading=true"
                    @loadingCompleted="loading=false"
                    @contractSelected="setContract"
                />
            </div>

            <div class="col-sm-6 nopads pl-1 pr-1">
                <contract-order-multiselect
                    ref="orderFilter"
                    :contract-ids="contract ?  [contract.id] : []"
                    :single-mode="true"
                    :show-title="false"
                    :pre-selected-order="preSelectedOrder ? preSelectedOrder.id : undefined"
                    @orders-selected="setOrder"
                />
            </div>
        </div>
        <div class="col-sm-12 d-flex justify-content-end">
            <button class="btn btn-secondary form-button" @click.stop="$emit('close')">
                {{ $t('common.cancel') }}
            </button>
            <button class="btn btn-success form-button" :disabled="loading || (!spreaderData.vehicle && !spreaderData.vehicle.license_plate) || !contract || !order" @click.stop="sendDataToHarja">
                {{ $t('common.send') }}
            </button>
        </div>
        <div
            v-if="loading"
            id="loader"
            class="spinner"
        ></div>
    </div>
</template>
<script>
import {restApi} from "@/components/mixins/RestApiMixin";
import {spreaderDataMixin} from "@/components/mixins/SpreaderDataMixin";
import {timeUtils} from '@/components/mixins/TimeUtils'
import SpreaderMaterialSelector from "@/components/materials/spreaderdata/SpreaderMaterialSelector"
import OpenContractFilter from "@/components/contract/OpenContractFilter";
import {inject} from "vue";
import ContractOrderMultiselect from "../../order/ContractOrderMultiselect.vue";

export default {
    name: 'SpreaderDataHarjaSender',
    props: {
        item: {
            type: Object,
            default() {
                return ({})
            }
        },
        user: {
            type: Object,
            default: null
        },
        isAdmin: Boolean,
        preSelectedOrder: {
            type: Object,
            default: null
        }
    },
    components: {ContractOrderMultiselect, OpenContractFilter, SpreaderMaterialSelector},
    mixins: [timeUtils, restApi, spreaderDataMixin],
    created() {
        this.spreaderData = JSON.parse(JSON.stringify(this.item))
        if (!this.spreaderData.vehicle) {
            this.spreaderData.vehicle = {
                license_plate: null,
            }
        }
    },
    data: function () {
        return {
            loading: false,
            spreaderData: {},
            licensePlate: null,
            orders: [],
            order: null,
            contract: null,
        }
    },
    watch: {
        licensePlate (val) {
            this.spreaderData.vehicle.license_plate = val
        }
    },
    setup() {
        // Inject parents alerter
        const showAlert = inject('showAlert')
        return { showAlert }
    },
    mounted() {
        this.licensePlate = this.spreaderData.vehicle.license_plate
        this.contract = this.spreaderData.contract
        this.order = this.preSelectedOrder
    },
    methods: {
        setContract: function (contract) {
            this.contract = contract
        },
        setOrder(order) {
            this.order = order
        },
        /**
         * @param  {{materialType: number, material: number|null, system: number}} material
         */
        setMaterial: function (material) {
            if(material.materialType === this.materialTypes.DRY) {
                this.spreaderData.material_dry = material.material
                this.spreaderData.dry_material_system = material.system
            } else {
                this.spreaderData.material_liquid = material.material
                this.spreaderData.liquid_material_system = material.system
            }
        },
        sendDataToHarja: function () {
            this.loading = true
            if(this.spreaderData && this.spreaderData.id) {
                const vehicle = {
                    ...this.spreaderData.vehicle,
                    license_plate: this.spreaderData.vehicle.license_plate ? this.spreaderData.vehicle.license_plate.trim() : null
                }
                const data = {
                    id: this.spreaderData.id,
                    vehicle: vehicle,
                    material_dry: this.spreaderData.material_dry ? Number(this.spreaderData.material_dry) : null,
                    material_liquid: this.spreaderData.material_liquid ? Number(this.spreaderData.material_liquid) : null,
                    total_dry_amount: this.spreaderData.total_dry_amount ? Number(this.spreaderData.total_dry_amount) : null,
                    total_liquid_amount: this.spreaderData.total_liquid_amount ? Number(this.spreaderData.total_liquid_amount) : null,
                    order: this.order
                }
                this.restAdd(this.spreaderDataToHarjaUrl, data, this.success, this.failed)
            }
        },
        success() {
            this.loading = false
            this.showAlert(this.$t('spreader_data.alert_send_success'), 'success')
            this.$emit('closeAndUpdate', this.order)
        },
        failed(response) {
            this.loading = false
            if(response && response.data && response.data.code) {
                switch(response.data.code) {
                    case 1:
                        this.showAlert(this.$t('spreader_data.errors.1'))
                        break
                    case 2:
                        this.showAlert(this.$t('spreader_data.errors.2'))
                        break
                    case 3:
                        this.showAlert(this.$t('spreader_data.errors.3'))
                        break
                    default:
                        this.showAlert(this.$t('spreader_data.alert_send_fail'))
                        break
                }
            } else {
                // Harja send failed. Item may contain additional information, so we need to update the list.
                this.$emit('triggerListUpdate')
                this.showAlert(this.$t('spreader_data.alert_send_fail'))
            }
        }
    }
}
</script>
